import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

export default function FlagCheck({ label, checked, onChange, testId, disabled }) {
  return (
    <label className="flex items-center gap-2 text-xs text-slate-700 cursor-pointer select-none">
      <Checkbox
        checked={!!checked}
        disabled={disabled}
        onCheckedChange={(v) => onChange(v === true)}
        data-testid={testId}
      />
      <span>{label}</span>
    </label>
  );
}
